export enum InstructionRSJIncomeType {
  Professional = 'Professional',
  Replacement = 'Replacement',
  Training = 'Training',
  SocialSupport = 'SocialSupport',
  Other = 'Other',
}
